import { IBudgetKanbanFilters } from "../../../../models/budgetV2";
import { useBudgetExport } from "../hooks/useBudgetExport";
import { useIntl } from "react-intl";

import "../index.scss";

export const BudgetExportButton = (filters: IBudgetKanbanFilters) => {
    const intl = useIntl();

    const { isExporting, handleExport } = useBudgetExport(filters);

    return (
        <>
            <button
                type="button"
                className="btn btn-default mt-[22px] budget-export-button w-full md:w-auto"
                aria-label="Baixar planilha com orçamentos aprovados"
                onClick={handleExport}
                disabled={isExporting}
            >
                <span className={`rioglyph ${isExporting ? "rioglyph-refresh spinning" : "rioglyph-download"}`} aria-hidden="true" />
                <span className="budget-export-button__label">{intl.formatMessage({ id: "intl-msg:budgets.kanban.exportButton" })}</span>
            </button>
        </>
    )
}